/* PAIX-V1 languages
   1. First visit: visitors in Denmark get Danish, visitors in France get French (once; after that their own choice is kept).
   2. EN / DA / FR switcher in the arcade menu and the top bar.
   3. Danish and French for the arcade parts of the shop (game, point shop, player profile, high scores, pop-ups).
   Loaded in <head> before the page is drawn, so visitors never see the English text first.
   SPEED (opgave 37): on the homepage it loads with defer. The arcade texts there come translated from the server
   (snippets/paix-t.liquid), and part 1 runs inline in layout/theme.liquid, so nothing changes for the visitor.
   Since 15/10 also on product and collection pages (nothing visible there needs it before the first paint). */
(function () {
  if (window.PXT) return;
  var html = document.documentElement;
  var LOC = window.PXLOC || {};
  var L = String(LOC.l || html.lang || 'en').slice(0, 2).toLowerCase();
  var LANGS = ['en', 'da', 'fr'].filter(function (x) { return !LOC.ls || LOC.ls.indexOf(x) !== -1; });
  function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function save(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  /* ---------- 1. Language by country, first visit only ---------- */
  var PRE = new RegExp('^/(' + LANGS.filter(function (x) { return x !== 'en'; }).join('|') + ')(?=/|$)');
  function bare(p) { return p.replace(PRE, '') || '/'; }
  function urlFor(lang, p) { p = bare(p || location.pathname); return lang === 'en' ? p : '/' + lang + (p === '/' ? '' : p); }
  var bot = /bot|crawl|spider|slurp|lighthouse|headless|preview|facebookexternalhit/i.test(navigator.userAgent);
  if (PRE.test(location.pathname)) save('pxLangAuto', '1');
  else if (L === 'en' && !read('pxLangAuto') && !bot && !window.Shopify?.designMode && !window.__pxLangGo) {
    save('pxLangAuto', '1');
    var c = String(LOC.c || '').toUpperCase();
    var nav = [].concat(navigator.languages || [], navigator.language || '').join(',').toLowerCase();
    var want = c === 'DK' ? 'da' : (c === 'FR' || c === 'MC') ? 'fr' : (/^(BE|LU|CH|CA)$/.test(c) && /(^|,)fr/.test(nav)) ? 'fr' : '';
    if (want && LANGS.indexOf(want) !== -1) { location.replace(urlFor(want) + location.search + location.hash); return; }
  }

  /* ---------- 2. Dictionary: [English, Danish, French] ---------- */
  var N = ' '; // French puts a non-breaking space before : ! ?
  var W = [
    /* arcade homepage */
    ['HOME', 'FORSIDE', 'ACCUEIL'],
    ['SHOP', 'SHOP', 'BOUTIQUE'],
    ['GIFT CARD', 'GAVEKORT', 'CARTE CADEAU'],
    ['THE STORY', 'HISTORIEN', 'L’HISTOIRE'],
    ['GAME', 'SPIL', 'JEU'],
    ['LOGIN', 'LOG IND', 'CONNEXION'],
    ['PLAYER PROFILE', 'SPILLERPROFIL', 'PROFIL JOUEUR'],
    ['↑ ↓ SELECT ENTER START', '↑ ↓ VÆLG' + N + ' ENTER START', '↑ ↓ CHOISIR' + N + ' ENTRÉE START'],
    ['TAP TO SELECT', 'TRYK FOR AT VÆLGE', 'TOUCHE POUR CHOISIR'],
    ['JOIN THE DROP LIST', 'KOM PÅ DROP-LISTEN', 'REJOINS LA LISTE DES DROPS'],
    ['Get new drops, restocks and members-only releases in your inbox first.', 'Få nye drops, restocks og eksklusive medlemsudgivelser først i din indbakke.', 'Reçois en avant-première les nouveaux drops, les réassorts et les sorties réservées aux membres.'],
    ['LATEST DROP', 'SENESTE DROP', 'DERNIER DROP'],
    ['NEW DROP', 'NYT DROP', 'NOUVEAU DROP'],
    ['NEW DROP ▸', 'NYT DROP ▸', 'NOUVEAU DROP ▸'],
    ['PAIX-V1 MEMBERSHIP', 'PAIX-V1 MEDLEMSKAB', 'ESPACE MEMBRE PAIX-V1'],
    ['JOIN FREE ▸', 'BLIV GRATIS MEDLEM ▸', 'INSCRIPTION GRATUITE ▸'],
    ['JOIN FREE', 'BLIV GRATIS MEDLEM', 'INSCRIPTION GRATUITE'],
    ['CONTINUE ▸', 'FORTSÆT ▸', 'CONTINUER ▸'],
    ['CONTINUE', 'FORTSÆT', 'CONTINUER'],
    ['MEMBERS-ONLY DROPS INCOMING', 'EKSKLUSIVE MEDLEMSDROPS PÅ VEJ', 'DROPS RÉSERVÉS AUX MEMBRES EN APPROCHE'],
    ['TOP 3 PLAYERS', 'TOP 3 SPILLERE', 'TOP 3 JOUEURS'],
    ['1ST', '1.', '1ER'], ['2ND', '2.', '2E'], ['3RD', '3.', '3E'],
    ['LOADING', 'INDLÆSER', 'CHARGEMENT'],
    ['HIGH SCORES ▸', 'HIGHSCORES ▸', 'MEILLEURS SCORES ▸'],
    ['HIGH SCORES', 'HIGHSCORES', 'MEILLEURS SCORES'],
    ['SKIP ▸▸', 'SPRING OVER ▸▸', 'PASSER ▸▸'],
    ['SOUND: OFF', 'LYD: FRA', 'SON' + N + ': OFF'],
    ['SOUND: ON', 'LYD: TIL', 'SON' + N + ': ON'],
    ['FREE SPOT', 'LEDIG PLADS', 'PLACE LIBRE'],
    ['PLAY NOW', 'SPIL NU', 'JOUE MAINTENANT'],
    ['PLAY NOW ▸', 'SPIL NU ▸', 'JOUE MAINTENANT ▸'],
    ['PLAY TO GET ON', 'SPIL DIG PÅ', 'JOUE POUR ENTRER'],
    ['THE BOARD', 'LISTEN', 'AU CLASSEMENT'],
    ['Main menu', 'Hovedmenu', 'Menu principal'],
    ['GAME OFFLINE - RETRY', 'SPILLET ER OFFLINE - PRØV IGEN', 'JEU HORS LIGNE - RÉESSAIE'],
    ['LOG IN TO EARN POINTS', 'LOG IND FOR AT FÅ POINT', 'CONNECTE-TOI POUR GAGNER DES POINTS'],
    ['POINTS SERVER OFFLINE', 'POINTSERVEREN ER OFFLINE', 'SERVEUR DE POINTS HORS LIGNE'],
    ['DAILY ARCADE POINTS MAXED', 'DAGENS ARKADEPOINT ER BRUGT', 'POINTS ARCADE DU JOUR AU MAXIMUM'],
    ['PLAY LONGER TO EARN POINTS', 'SPIL LÆNGERE FOR AT FÅ POINT', 'JOUE PLUS LONGTEMPS POUR GAGNER DES POINTS'],
    ['SCORE NOT ACCEPTED', 'SCOREN BLEV IKKE GODKENDT', 'SCORE NON VALIDÉ'],
    ['SCORE MORE TO EARN POINTS', 'SCOR MERE FOR AT FÅ POINT', 'MARQUE PLUS POUR GAGNER DES POINTS'],
    ['NO POINTS THIS ROUND', 'INGEN POINT I DENNE RUNDE', 'PAS DE POINTS CETTE PARTIE'],
    ['Point table', 'Pointtavle', 'Tableau des scores'],
    ['FULL LEADERBOARD ▸', 'HELE TOPLISTEN ▸', 'CLASSEMENT COMPLET ▸'],
    ['TAP OUTSIDE OR PRESS ENTER TO PLAY AGAIN', 'TRYK UDENFOR ELLER PÅ ENTER FOR AT SPILLE IGEN', 'TOUCHE À CÔTÉ OU APPUIE SUR ENTRÉE POUR REJOUER'],
    ['NO SCORES YET', 'INGEN SCORER ENDNU', 'PAS ENCORE DE SCORES'],
    ['YOUR TOP 10', 'DIN TOP 10', 'TON TOP 10'],
    ['TOP 10 THIS MONTH', 'TOP 10', 'TOP 10'],
    ['TOP 10 THIS WEEK', 'UGENS TOP 10', 'TOP 10 DE LA SEMAINE'],
    ['★ NEW RECORD! SAVED TO THE LIST ★', '★ NY REKORD! GEMT PÅ LISTEN ★', '★ NOUVEAU RECORD' + N + '! ENREGISTRÉ ★'],
    ['YOU', 'DIG', 'TOI'],
    ['CHANGE YOUR NAME', 'SKIFT DIT NAVN', 'CHANGE TON NOM'],
    ['ENTER YOUR NAME FOR THE HIGH SCORE LIST', 'SKRIV DIT NAVN TIL HIGHSCORELISTEN', 'ENTRE TON NOM POUR LE CLASSEMENT'],
    ['SAVE ▶', 'GEM ▶', 'VALIDER ▶'],
    ['SAVE', 'GEM', 'ENREGISTRER'],
    ['3-12 LETTERS, NUMBERS, - OR _', '3-12 BOGSTAVER, TAL, - ELLER _', '3 À 12 LETTRES, CHIFFRES, - OU _'],
    ['SAVING...', 'GEMMER...', 'ENREGISTREMENT...'],
    ['THAT NAME IS TAKEN', 'NAVNET ER TAGET', 'CE NOM EST DÉJÀ PRIS'],
    ['THAT NAME IS TAKEN.', 'NAVNET ER TAGET.', 'CE NOM EST DÉJÀ PRIS.'],
    ['PICK ANOTHER NAME', 'VÆLG ET ANDET NAVN', 'CHOISIS UN AUTRE NOM'],
    ['PICK ANOTHER NAME.', 'VÆLG ET ANDET NAVN.', 'CHOISIS UN AUTRE NOM.'],
    ['OPEN YOUR PLAYER PROFILE FIRST', 'ÅBN DIN SPILLERPROFIL FØRST', 'OUVRE D’ABORD TON PROFIL JOUEUR'],
    ['OPEN YOUR PLAYER PROFILE FIRST.', 'ÅBN DIN SPILLERPROFIL FØRST.', 'OUVRE D’ABORD TON PROFIL JOUEUR.'],
    ['USE 3-12 LETTERS, NUMBERS, - OR _.', 'BRUG 3-12 BOGSTAVER, TAL, - ELLER _.', 'UTILISE 3 À 12 LETTRES, CHIFFRES, - OU _.'],
    ['ON THE LIST AS', 'PÅ LISTEN SOM', 'AU CLASSEMENT SOUS LE NOM'],
    ['CHANGE', 'SKIFT', 'MODIFIER'],
    ['WANT YOUR NAME ON THE HIGH SCORE LIST?', 'VIL DU HAVE DIT NAVN PÅ HIGHSCORELISTEN?', 'TU VEUX TON NOM AU CLASSEMENT' + N + '?'],
    ['LOG IN / JOIN FREE ▶', 'LOG IND / BLIV GRATIS MEDLEM ▶', 'CONNEXION / INSCRIPTION GRATUITE ▶'],
    ['LOGIN / JOIN FREE', 'LOG IND / BLIV GRATIS MEDLEM', 'CONNEXION / INSCRIPTION GRATUITE'],
    ['EXIT ✕', 'AFSLUT ✕', 'QUITTER ✕'],
    ['Game. Arrow keys or A and D move, Space fires, P pauses, Escape exits.', 'Spil. Piletasterne eller A og D flytter, mellemrum skyder, P pauser, Escape afslutter.', 'Jeu. Flèches ou A et D pour bouger, Espace pour tirer, P pour la pause, Échap pour quitter.'],
    ['Move left', 'Flyt til venstre', 'Aller à gauche'],
    ['Move right', 'Flyt til højre', 'Aller à droite'],
    ['Fire', 'Skyd', 'Tirer'],

    /* the game (canvas) */
    ['DEFEND THE PEACE', 'FORSVAR FREDEN', 'DÉFENDS LA PAIX'],
    ['FREEDOM CULTURE PEACE', 'FRIHED KULTUR FRED', 'LIBERTÉ CULTURE PAIX'],
    ['LEVELS: RESPECT LOYALTY', 'NIVEAUER: RESPEKT LOYALITET', 'NIVEAUX' + N + ': RESPECT LOYAUTÉ'],
    ['CATCH P A I X = 1UP', 'FANG  P A I X  = 1UP', 'ATTRAPE  P A I X  = 1UP'],
    ['TAP TO START', 'TRYK FOR AT STARTE', 'TOUCHE POUR JOUER'],
    ['PRESS ENTER', 'TRYK ENTER', 'APPUIE SUR ENTRÉE'],
    ['TAP TO RESTART', 'TRYK FOR AT SPILLE IGEN', 'TOUCHE POUR REJOUER'],
    ['ENTER TO RESTART', 'ENTER FOR AT SPILLE IGEN', 'ENTRÉE POUR REJOUER'],
    ['SLIDE FINGER - AUTO FIRE', 'TRÆK FINGEREN - AUTOSKUD', 'GLISSE LE DOIGT - TIR AUTO'],
    ['ARROWS MOVE SPACE FIRE', 'PILE FLYTTER  MELLEMRUM SKYDER', 'FLÈCHES BOUGER  ESPACE TIRER'],
    ['UPGRADE YOUR SHIP IN POINT SHOP', 'OPGRADÉR DIT SKIB I POINT SHOP', 'AMÉLIORE TON VAISSEAU AU POINT SHOP'],
    ['PAUSED', 'PAUSE', 'PAUSE'],
    ['LEVEL', 'NIVEAU', 'NIVEAU'],
    ['NEW HIGH SCORE!', 'NY HIGHSCORE!', 'NOUVEAU RECORD' + N + '!'],
    ['WARNING!', 'ADVARSEL!', 'ATTENTION' + N + '!'],
    ['BOSS INCOMING', 'BOSS PÅ VEJ', 'BOSS EN APPROCHE'],
    ['ARMORED', 'PANSRET', 'BLINDÉ'],
    ['STATIC', 'STATISK', 'STATIQUE'],
    ['DEEP SPACE', 'DYBT RUM', 'ESPACE PROFOND'],
    ['NEON GRID', 'NEONGITTER', 'GRILLE NÉON'],
    ['NIGHT CITY', 'NATTEBY', 'VILLE DE NUIT'],
    ['THUNDER STORM', 'TORDENVEJR', 'ORAGE'],
    ['NEBULA', 'STJERNETÅGE', 'NÉBULEUSE'],
    ['RESPECT', 'RESPEKT', 'RESPECT'],
    ['LOYALTY', 'LOYALITET', 'LOYAUTÉ'],
    ['FREEDOM', 'FRIHED', 'LIBERTÉ'],
    ['CULTURE', 'KULTUR', 'CULTURE'],
    ['PEACE', 'FRED', 'PAIX'],
    ['EYE TITAN', 'ØJE-TITAN', 'TITAN DE L’ŒIL'],
    ['SKULL FORTRESS', 'KRANIEFÆSTNING', 'FORTERESSE CRÂNE'],
    ['WING BEAST', 'VINGEBÆST', 'BÊTE AILÉE'],
    ['SPREAD SHOT', 'SPREDESKUD', 'TIR DISPERSÉ'],
    ['HUNTER BURST', 'JÆGERSALVE', 'SALVE TRAQUEUSE'],
    ['STORM RING', 'STORMRING', 'ANNEAU D’ORAGE'],
    ['GRID', 'GITTER', 'GRILLE'],
    ['CHECKER', 'SKAKBRÆT', 'DAMIER'],
    ['PYRAMID', 'PYRAMIDE', 'PYRAMIDE'],
    ['WAVE', 'BØLGE', 'VAGUE'],
    ['TWIN BLOCKS', 'TVILLINGBLOKKE', 'BLOCS JUMEAUX'],
    ['DIAMOND', 'DIAMANT', 'DIAMANT'],
    ['V-WING', 'V-VINGE', 'AILE EN V'],
    ['DRIFT', 'DRIFT', 'DÉRIVE'],
    ['SPLITTERS', 'SPLITTERE', 'DIVISEURS'],
    ['ZIGZAG FIRE', 'ZIGZAGSKUD', 'TIR EN ZIGZAG'],
    ['MINE FIELD', 'MINEFELT', 'CHAMP DE MINES'],
    ['RAPID SWARM', 'LYNSVÆRM', 'ESSAIM RAPIDE'],
    ['DIVE STORM', 'STYRTSTORM', 'PIQUÉS EN RAFALE'],
    ['GHOSTS', 'SPØGELSER', 'FANTÔMES'],
    ['ZAPPERS', 'ZAPPERE', 'ZAPPEURS'],
    ['HOPPERS', 'HOPPERE', 'SAUTEURS'],
    ['METEOR SHOWER!', 'METEORREGN!', 'PLUIE DE MÉTÉORES' + N + '!'],
    ['POWER RAIN!', 'POWER-REGN!', 'PLUIE DE BONUS' + N + '!'],
    ['COIN STORM!', 'MØNTSTORM!', 'TEMPÊTE DE PIÈCES' + N + '!'],
    ['RAPID FIRE!', 'HURTIG ILD!', 'TIR RAPIDE' + N + '!'],
    ['TRIPLE SHOT!', 'TRIPPELSKUD!', 'TIR TRIPLE' + N + '!'],
    ['SHIELD!', 'SKJOLD!', 'BOUCLIER' + N + '!'],
    ['EXTRA LIFE!', 'EKSTRA LIV!', 'VIE BONUS' + N + '!'],

    /* player profile + point shop + rewards from the membership server */
    ['LOADING PLAYER DATA', 'INDLÆSER SPILLERDATA', 'CHARGEMENT DU PROFIL'],
    ['PLAY ARCADE', 'SPIL ARKADE', 'JOUER À L’ARCADE'],
    ['ORDERS & ACCOUNT', 'ORDRER & KONTO', 'COMMANDES & COMPTE'],
    ['Account', 'Konto', 'Compte'],
    ['Membership', 'Medlemskab', 'Espace membre'],
    ['Log in or create a free account to collect points, unlock levels and claim monthly rewards.', 'Log ind eller opret en gratis konto for at samle point, låse nye niveauer op og hente månedlige belønninger.', 'Connecte-toi ou crée un compte gratuit pour cumuler des points, débloquer des niveaux et récupérer tes récompenses mensuelles.'],
    ['COPY', 'KOPIÉR', 'COPIER'],
    ['COPIED', 'KOPIERET', 'COPIÉ'],
    ['COPY CODE', 'KOPIÉR KODE', 'COPIER LE CODE'],
    ['POINTS', 'POINT', 'POINTS'],
    ['AVAILABLE REWARDS', 'TILGÆNGELIGE BELØNNINGER', 'RÉCOMPENSES DISPONIBLES'],
    ['MONTHLY REWARD', 'MÅNEDENS BELØNNING', 'RÉCOMPENSE DU MOIS'],
    ['READY TO CLAIM', 'KLAR TIL AT HENTE', 'PRÊTE À RÉCUPÉRER'],
    ['READY', 'KLAR', 'PRÊTE'],
    ['NONE', 'INGEN', 'AUCUNE'],
    ['CLAIMED', 'HENTET', 'RÉCUPÉRÉ'],
    ['EXPIRED', 'UDLØBET', 'EXPIRÉ'],
    ['LOCKED', 'LÅST', 'VERROUILLÉ'],
    ['MAX LEVEL REACHED', 'HØJESTE NIVEAU NÅET', 'NIVEAU MAXIMUM ATTEINT'],
    ['NO MONTHLY REWARD RIGHT NOW.', 'INGEN MÅNEDLIG BELØNNING LIGE NU.', 'PAS DE RÉCOMPENSE MENSUELLE POUR LE MOMENT.'],
    ['MONTHLY BONUS: 10% OFF', 'MÅNEDSBONUS: 10% RABAT', 'BONUS DU MOIS' + N + ': -10' + N + '%'],
    ['One use. Valid 14 days from claim.', 'Kan bruges én gang. Gælder i 14 dage, fra du henter den.', 'Usage unique. Valable 14 jours après récupération.'],
    ['CLAIM', 'HENT', 'RÉCUPÉRER'],
    ['CLAIMING...', 'HENTER...', 'RÉCUPÉRATION...'],
    ['MONTHLY REWARD CLAIMED!', 'MÅNEDENS BELØNNING ER HENTET!', 'RÉCOMPENSE DU MOIS RÉCUPÉRÉE' + N + '!'],
    ['EXPIRED. A NEW REWARD ARRIVES NEXT MONTH.', 'UDLØBET. EN NY BELØNNING KOMMER NÆSTE MÅNED.', 'EXPIRÉE. UNE NOUVELLE RÉCOMPENSE ARRIVE LE MOIS PROCHAIN.'],
    ['LOCKED. REACH A HIGHER LEVEL TO UNLOCK.', 'LÅST. NÅ ET HØJERE NIVEAU FOR AT LÅSE OP.', 'VERROUILLÉ. ATTEINS UN NIVEAU SUPÉRIEUR POUR LE DÉBLOQUER.'],
    ['REWARDS', 'BELØNNINGER', 'RÉCOMPENSES'],
    ['REDEEM', 'INDLØS', 'ÉCHANGER'],
    ['WORKING...', 'ARBEJDER...', 'EN COURS...'],
    ['YOUR CODES', 'DINE KODER', 'TES CODES'],
    ['NO CODES YET.', 'INGEN KODER ENDNU.', 'PAS ENCORE DE CODES.'],
    ['EXCLUSIVE DROPS', 'EKSKLUSIVE DROPS', 'DROPS EXCLUSIFS'],
    ['ENTER', 'GÅ IND', 'ENTRER'],
    ['POINTS HISTORY', 'POINTHISTORIK', 'HISTORIQUE DES POINTS'],
    ['WELCOME BONUS', 'VELKOMSTBONUS', 'BONUS DE BIENVENUE'],
    ['PURCHASE', 'KØB', 'ACHAT'],
    ['REFUND', 'REFUSION', 'REMBOURSEMENT'],
    ['CANCELLED ORDER', 'ANNULLERET ORDRE', 'COMMANDE ANNULÉE'],
    ['ARCADE', 'ARKADE', 'ARCADE'],
    ['REWARD', 'BELØNNING', 'RÉCOMPENSE'],
    ['POINTS RETURNED', 'POINT RETURNERET', 'POINTS RESTITUÉS'],
    ['ADJUSTMENT', 'JUSTERING', 'AJUSTEMENT'],
    ['WEEKLY', 'UGENS VINDER', 'VAINQUEUR DE LA SEMAINE'],
    ['NO ACTIVITY YET.', 'INGEN AKTIVITET ENDNU.', 'AUCUNE ACTIVITÉ POUR L’INSTANT.'],
    ['LOGIN REQUIRED', 'LOGIN PÅKRÆVET', 'CONNEXION REQUISE'],
    ['MEMBERSHIP SERVER OFFLINE', 'MEDLEMSSERVEREN ER OFFLINE', 'SERVEUR MEMBRES HORS LIGNE'],
    ['PLEASE LOG IN AGAIN.', 'LOG VENLIGST IND IGEN.', 'MERCI DE TE RECONNECTER.'],
    ['YOUR POINTS ARE SAFE. TRY AGAIN IN A MOMENT.', 'DINE POINT ER I SIKKERHED. PRØV IGEN OM LIDT.', 'TES POINTS SONT EN SÉCURITÉ. RÉESSAIE DANS UN INSTANT.'],
    ['NOT ENOUGH POINTS.', 'IKKE NOK POINT.', 'PAS ASSEZ DE POINTS.'],
    ['YOUR LEVEL IS TOO LOW FOR THIS REWARD.', 'DIT NIVEAU ER FOR LAVT TIL DENNE BELØNNING.', 'TON NIVEAU EST TROP BAS POUR CETTE RÉCOMPENSE.'],
    ['YOU ALREADY CLAIMED THIS REWARD.', 'DU HAR ALLEREDE HENTET DENNE BELØNNING.', 'TU AS DÉJÀ RÉCUPÉRÉ CETTE RÉCOMPENSE.'],
    ['THAT REWARD DOES NOT EXIST.', 'DEN BELØNNING FINDES IKKE.', 'CETTE RÉCOMPENSE N’EXISTE PAS.'],
    ['COULD NOT CREATE YOUR CODE. POINTS RETURNED.', 'KUNNE IKKE OPRETTE DIN KODE. DINE POINT ER RETURNERET.', 'IMPOSSIBLE DE CRÉER TON CODE. TES POINTS SONT RESTITUÉS.'],
    ['COULD NOT CREATE YOUR CODE. TRY AGAIN.', 'KUNNE IKKE OPRETTE DIN KODE. PRØV IGEN.', 'IMPOSSIBLE DE CRÉER TON CODE. RÉESSAIE.'],
    ['ALREADY CLAIMED THIS MONTHSTR.', 'ALLEREDE HENTET DENNE MÅNED.', 'DÉJÀ RÉCUPÉRÉE CE MOIS-CI.'],
    ['ERROR', 'FEJL', 'ERREUR'],
    ['TURBO ENGINE', 'TURBOMOTOR', 'MOTEUR TURBO'],
    ['RAPID FIRE', 'HURTIG ILD', 'TIR RAPIDE'],
    ['EXTRA LIFE', 'EKSTRA LIV', 'VIE BONUS'],
    ['TWIN CANNON', 'DOBBELTKANON', 'CANON DOUBLE'],
    ['SPREAD CANNON', 'SPREDEKANON', 'CANON DISPERSÉ'],
    ['FOLLOW @PAIXV1: 5% OFF', 'FØLG @PAIXV1: 5% RABAT', 'SUIS @PAIXV1' + N + ': -5' + N + '%'],
    ['FREE SHIPPING', 'GRATIS FRAGT', 'LIVRAISON OFFERTE'],
    ['MYSTERY TEE', 'MYSTERY TEE', 'T-SHIRT MYSTÈRE'],
    ['MYSTERY DROP', 'MYSTERY DROP', 'DROP MYSTÈRE'],
    ['WEEKLY CHAMPION: 20% OFF', 'UGENS MESTER: 20% RABAT', 'CHAMPION DE LA SEMAINE' + N + ': -20' + N + '%'],
    ['Your ship moves 40% faster. Yours forever.', 'Dit skib flyver 40% hurtigere. Din for altid.', 'Ton vaisseau va 40' + N + '% plus vite. À toi pour toujours.'],
    ['Reload almost twice as fast. Yours forever.', 'Genlad næsten dobbelt så hurtigt. Din for altid.', 'Recharge presque deux fois plus vite. À toi pour toujours.'],
    ['Start every game with 4 lives instead of 3.', 'Start hvert spil med 4 liv i stedet for 3.', 'Commence chaque partie avec 4 vies au lieu de 3.'],
    ['Fire two shots at once.', 'Skyd to skud på én gang.', 'Tire deux coups à la fois.'],
    ['Fire three shots in a spread. STREET PLAYER and up.', 'Skyd tre skud i vifte. Fra STREET PLAYER og op.', 'Tire trois coups en éventail. Dès le niveau STREET PLAYER.'],
    ['Follow @paixv1 on Instagram and get a one-time 5% code. One per player.', 'Følg @paixv1 på Instagram og få en engangskode på 5%. Én pr. spiller.', 'Suis @paixv1 sur Instagram et reçois un code de -5' + N + '% à usage unique. Un par joueur.'],
    ['??? A secret PAIX-V1 tee, picked by us. Choose your size, add the MYSTERY TEE to your cart and use the code at checkout.', '??? En hemmelig PAIX-V1 tee, udvalgt af os. Vælg din størrelse, læg MYSTERY TEE i kurven og brug koden ved betalingen.', '??? Un t-shirt PAIX-V1 secret, choisi par nous. Choisis ta taille, ajoute le T-SHIRT MYSTÈRE au panier et utilise le code au paiement.'],
    ['??? A secret PAIX-V1 item, picked and packed by us. Add the MYSTERY DROP to your cart and use the code at checkout.', '??? En hemmelig PAIX-V1 vare, udvalgt og pakket af os. Læg MYSTERY DROP i kurven og brug koden ved betalingen.', '??? Un article PAIX-V1 secret, choisi et emballé par nous. Ajoute le DROP MYSTÈRE au panier et utilise le code au paiement.'],
    ['POINT SHOP', 'POINT SHOP', 'POINT SHOP'],
    ['Spend your points on gear, discounts and member-only rewards.', 'Brug dine point på tøj, rabatter og eksklusive medlemsbelønninger.', 'Dépense tes points en vêtements, réductions et récompenses réservées aux membres.'],
    ['YOUR POINTS', 'DINE POINT', 'TES POINTS'],
    ['SHIP UPGRADES', 'SKIBSOPGRADERINGER', 'AMÉLIORATIONS DU VAISSEAU'],
    ['LOADING SHOP', 'INDLÆSER SHOP', 'CHARGEMENT DE LA BOUTIQUE'],
    ['EARN POINTS: PLAY', 'FÅ POINT: SPIL', 'GAGNE DES POINTS' + N + ': JOUE'],
    ['SHOP GEAR', 'SHOP TØJ', 'VOIR LA BOUTIQUE'],
    ['Log in to see your points and spend them in the POINT SHOP.', 'Log ind for at se dine point og bruge dem i POINT SHOP.', 'Connecte-toi pour voir tes points et les dépenser au POINT SHOP.'],
    ['FREE', 'GRATIS', 'GRATUIT'],
    ['INSTALLED ✓', 'INSTALLERET ✓', 'INSTALLÉ ✓'],
    ['BUY UPGRADE', 'KØB OPGRADERING', 'ACHETER'],
    ['BUY WITH POINTS', 'KØB MED POINT', 'ÉCHANGER CONTRE DES POINTS'],
    ['CLAIM CODE', 'HENT KODE', 'OBTENIR LE CODE'],
    ['FOLLOW ON INSTAGRAM ▸', 'FØLG PÅ INSTAGRAM ▸', 'SUIVRE SUR INSTAGRAM ▸'],
    ['FOLLOW FIRST', 'FØLG FØRST', 'ABONNE-TOI D’ABORD'],
    ['CONFIRM: I FOLLOW', 'BEKRÆFT: JEG FØLGER', 'CONFIRMER' + N + ': JE SUIS ABONNÉ'],
    ['PROCESSING...', 'BEHANDLER...', 'TRAITEMENT...'],
    ['GO TO CART', 'GÅ TIL KURVEN', 'VOIR LE PANIER'],
    ['GO TO PRODUCT', 'GÅ TIL PRODUKTET', 'VOIR LE PRODUIT'],
    ['INSTALLED ON YOUR SHIP', 'INSTALLERET PÅ DIT SKIB', 'INSTALLÉ SUR TON VAISSEAU'],
    ['YOUR CODE', 'DIN KODE', 'TON CODE'],
    ['SHIP UPGRADED', 'SKIB OPGRADERET', 'VAISSEAU AMÉLIORÉ'],
    ['REWARD UNLOCKED', 'BELØNNING LÅST OP', 'RÉCOMPENSE DÉBLOQUÉE'],
    ['THANKS FOR FOLLOWING', 'TAK FORDI DU FØLGER OS', 'MERCI DE NOUS SUIVRE'],
    ['MECHANIC', 'MEKANIKER', 'MÉCANO'],
    ['POINT SHOPPER', 'POINT-SHOPPER', 'CHASSEUR DE RÉCOMPENSES'],
    ['POINT SHOP OFFLINE. YOUR POINTS ARE SAFE. TRY AGAIN SOON.', 'POINT SHOP ER OFFLINE. DINE POINT ER I SIKKERHED. PRØV IGEN SNART.', 'POINT SHOP HORS LIGNE. TES POINTS SONT EN SÉCURITÉ. RÉESSAIE BIENTÔT.'],

    /* high scores page */
    ['PAIX-V1: DEFEND THE PEACE', 'PAIX-V1: FORSVAR FREDEN', 'PAIX-V1' + N + ': DÉFENDS LA PAIX'],
    ['Top 10 players of PAIX-V1: DEFEND THE PEACE.', 'Top 10 spillere i PAIX-V1: FORSVAR FREDEN.', 'Les 10 meilleurs joueurs de PAIX-V1' + N + ': DÉFENDS LA PAIX.'],
    ['THIS WEEK', 'DENNE UGE', 'CETTE SEMAINE'],
    ['THIS MONTH', 'DENNE MÅNED', 'CE MOIS-CI'],
    ['ALL TIME', 'ALLE TIDER', 'DEPUIS TOUJOURS'],
    ['WEEKLY TOURNAMENT', 'UGENTLIG TURNERING', 'TOURNOI DE LA SEMAINE'],
    ['♛ WEEKLY TOURNAMENT', '♛ UGENTLIG TURNERING', '♛ TOURNOI DE LA SEMAINE'],
    ['This week\'s #1 wins', 'Ugens #1 vinder', 'Le n°1 de la semaine gagne'],
    ['20% off', '20% rabat', '-20' + N + '%'],
    ['. The board resets every Monday.', '. Listen nulstilles hver mandag.', '. Le classement repart à zéro chaque lundi.'],
    ['NEW WEEK IN', 'NY UGE OM', 'NOUVELLE SEMAINE DANS'],
    ['★ LAST WEEK\'S WINNER ★', '★ SIDSTE UGES VINDER ★', '★ VAINQUEUR DE LA SEMAINE DERNIÈRE ★'],
    ['LOADING HIGH SCORES', 'INDLÆSER HIGHSCORES', 'CHARGEMENT DES SCORES'],
    ['YOUR PLAYER NAME', 'DIT SPILLERNAVN', 'TON NOM DE JOUEUR'],
    ['This name is shown on the leaderboard instead of your player number. 3-12 letters, numbers, - or _.', 'Navnet vises på toplisten i stedet for dit spillernummer. 3-12 bogstaver, tal, - eller _.', 'Ce nom apparaît au classement à la place de ton numéro de joueur. 3 à 12 lettres, chiffres, - ou _.'],
    ['PLAYER NAME', 'SPILLERNAVN', 'NOM DE JOUEUR'],
    ['WANT YOUR NAME UP HERE?', 'VIL DU HAVE DIT NAVN HEROP?', 'TU VEUX TON NOM ICI' + N + '?'],
    ['Log in, play GAME and your best score of the month lands on the board.', 'Log ind, spil SPIL, og din bedste score i måneden kommer på listen.', 'Connecte-toi, joue au JEU et ton meilleur score du mois entre au classement.'],
    ['LEADERBOARD OFFLINE. TRY AGAIN SOON.', 'TOPLISTEN ER OFFLINE. PRØV IGEN SNART.', 'CLASSEMENT HORS LIGNE. RÉESSAIE BIENTÔT.'],
    ['NO SCORES YET. BE THE FIRST!', 'INGEN SCORER ENDNU. VÆR DEN FØRSTE!', 'PAS ENCORE DE SCORES. SOIS LE PREMIER' + N + '!'],
    ['NAME ON THE BOARD', 'NAVN PÅ LISTEN', 'NOM AU CLASSEMENT'],

    /* next drop countdown */
    ['NEXT DROP', 'NÆSTE DROP', 'PROCHAIN DROP'],
    ['Next drop', 'Næste drop', 'Prochain drop'],
    ['DAYS', 'DAGE', 'JOURS'],
    ['HRS', 'TIM', 'H'],
    ['MIN', 'MIN', 'MIN'],
    ['SEC', 'SEK', 'SEC'],
    ['DROP IS LIVE ▸', 'DROPPET ER LIVE ▸', 'LE DROP EST EN LIGNE ▸'],
    ['The drop is live.', 'Droppet er live.', 'Le drop est en ligne.'],

    /* drop list pop-up */
    /* L1 (opgave 63): plain button and success texts */
    ['SIGN UP', 'TILMELD', 'JE M’INSCRIS'],
    ['YOU\'RE ON THE LIST!', 'DU ER PÅ LISTEN!', 'TU ES SUR LA LISTE' + N + '!'],
    ['✓ READY ▶ SIGN UP', '✓ KLAR ▶ TILMELD', '✓ PRÊT ▶ JE M’INSCRIS'],
    ['PLAYER REGISTERED. YOU\'RE ON THE LIST!', 'SPILLER REGISTRERET. DU ER PÅ LISTEN!', 'JOUEUR ENREGISTRÉ. TU ES SUR LA LISTE' + N + '!'],
    ['E-MAIL', 'E-MAIL', 'E-MAIL'],
    ['you@email.com', 'din@mail.dk', 'toi@email.fr'],
    ['You can unsubscribe anytime. See our', 'Du kan altid afmelde dig. Læs vores', 'Tu peux te désabonner à tout moment. Consulte notre'],
    ['privacy policy', 'privatlivspolitik', 'politique de confidentialité'],
    ['◆ HUMAN CHECK ◆', '◆ MENNESKE-TJEK ◆', '◆ TEST HUMAIN ◆'],
    ['SHOOT THE INVADER', 'SKYD RUMVÆSENET', 'ABATS L’ENVAHISSEUR'],
    ['PROVE YOU\'RE NOT A ROBOT.', 'BEVIS, AT DU IKKE ER EN ROBOT.', 'PROUVE QUE TU N’ES PAS UN ROBOT.'],
    ['PLAYER REGISTERED', 'SPILLER REGISTRERET', 'JOUEUR ENREGISTRÉ'],
    ['You\'re on the drop list. Watch your inbox.', 'Du er på drop-listen. Hold øje med din indbakke.', 'Tu es sur la liste des drops. Surveille ta boîte mail.'],
    ['✉ DROP LIST', '✉ DROP-LISTE', '✉ LISTE DES DROPS'],
    ['VERIFYING...', 'TJEKKER...', 'VÉRIFICATION...'],
    ['TOO FAST. TRY AGAIN.', 'FOR HURTIGT. PRØV IGEN.', 'TROP RAPIDE. RÉESSAIE.'],
    ['CHECK YOUR E-MAIL.', 'TJEK DIN E-MAIL.', 'VÉRIFIE TON E-MAIL.'],
    ['SERVER BUSY. TRY AGAIN SOON.', 'SERVEREN HAR TRAVLT. PRØV IGEN OM LIDT.', 'SERVEUR OCCUPÉ. RÉESSAIE BIENTÔT.'],
    ['SOMETHING WENT WRONG. TRY AGAIN.', 'NOGET GIK GALT. PRØV IGEN.', 'UN PROBLÈME EST SURVENU. RÉESSAIE.'],
    ['WELCOME TO THE DROP LIST', 'VELKOMMEN PÅ DROP-LISTEN', 'BIENVENUE SUR LA LISTE DES DROPS'],
    ['JOINED THE DROP LIST', 'PÅ DROP-LISTEN', 'INSCRIT À LA LISTE DES DROPS'],
    ['Close', 'Luk', 'Fermer'],
    ['Invader. Press to shoot.', 'Rumvæsen. Tryk for at skyde.', 'Envahisseur. Appuie pour tirer.'],
    ['is invalid', 'er ugyldig', 'n’est pas valide'],

    /* effects: banners, achievements, top bar, sound */
    ['ACHIEVEMENT UNLOCKED', 'BEDRIFT LÅST OP', 'SUCCÈS DÉBLOQUÉ'],
    ['FIRST LOOT', 'FØRSTE BYTTE', 'PREMIER BUTIN'],
    ['NEW PLAYER JOINED', 'NY SPILLER ER MED', 'NOUVEAU JOUEUR'],
    ['FIRST ORDER. LEGEND.', 'FØRSTE ORDRE. LEGENDE.', 'PREMIÈRE COMMANDE. LÉGENDE.'],
    ['GEAR INSPECTED', 'TØJET ER TJEKKET', 'ÉQUIPEMENT INSPECTÉ'],
    ['ENTERED THE SHOP', 'GIK IND I SHOPPEN', 'ENTRÉE DANS LA BOUTIQUE'],
    ['LORE UNLOCKED', 'HISTORIEN LÅST OP', 'HISTOIRE DÉBLOQUÉE'],
    ['PLAYER ONE READY', 'SPILLER ET ER KLAR', 'JOUEUR 1 PRÊT'],
    ['WEEKLY CHAMPION', 'UGENS MESTER', 'CHAMPION DE LA SEMAINE'],
    ['ON THE WAITLIST', 'PÅ VENTELISTEN', 'SUR LISTE D’ATTENTE'],
    ['READY PLAYER ONE ▶ PRESS START', 'SPILLER ET KLAR ▶ PRESS START', 'JOUEUR 1 PRÊT ▶ PRESS START'],
    ['ENTERING NAME...', 'SKRIVER NAVN...', 'SAISIE DU NOM...'],
    ['LOADING DOMAIN...', 'INDLÆSER DOMÆNE...', 'CHARGEMENT DU DOMAINE...'],
    ['TRANSMITTING...', 'SENDER...', 'TRANSMISSION...'],
    ['LOGIN TO START ▶', 'LOG IND FOR AT STARTE ▶', 'CONNECTE-TOI POUR JOUER ▶'],
    ['PLAYER PROFILE ▶', 'SPILLERPROFIL ▶', 'PROFIL JOUEUR ▶'],
    ['PLAY ▶', 'SPIL ▶', 'JOUER ▶'],
    ['LVL', 'NIV.', 'NIV.'],
    ['♫ SOUND ON', '♫ LYD TIL', '♫ SON ON'],
    ['♫ SOUND OFF', '♫ LYD FRA', '♫ SON OFF'],
    ['♪ MUSIC ON', '♪ MUSIK TIL', '♪ MUSIQUE ON'],
    ['♪ MUSIC OFF', '♪ MUSIK FRA', '♪ MUSIQUE OFF'],
    ['ADDED TO CART', 'LAGT I KURVEN', 'AJOUTÉ AU PANIER'],
    ['LOG IN', 'LOG IND', 'CONNECTE-TOI'],
    ['✓ SECURE CHECKOUT · MOBILEPAY, APPLE PAY & CARDS', '✓ SIKKER BETALING · MOBILEPAY, APPLE PAY & KORT', '✓ PAIEMENT SÉCURISÉ · MOBILEPAY, APPLE PAY & CARTE BANCAIRE'],
    ['✓ 14-DAY RETURNS · 24-MONTH WARRANTY', '✓ 14 DAGES RETURRET · 24 MÅNEDERS REKLAMATIONSRET', '✓ RETOURS SOUS 14 JOURS · GARANTIE LÉGALE 24 MOIS'],
    ['✓ FAST SHIPPING WITH POSTNORD', '✓ HURTIG LEVERING MED POSTNORD', '✓ LIVRAISON RAPIDE AVEC POSTNORD'],
    ['ADD TO CART ▶', 'LÆG I KURV ▶', 'AJOUTER AU PANIER ▶'],
    ['ADD TO CART', 'LÆG I KURV', 'AJOUTER AU PANIER'],
    ['SOLD OUT', 'UDSOLGT', 'ÉPUISÉ'],
    ['▦ SIZE GUIDE', '▦ STØRRELSESGUIDE', '▦ GUIDE DES TAILLES'],
    ['▦ FIND YOUR SIZE', '▦ FIND DIN STØRRELSE', '▦ TROUVE TA TAILLE'],
    ['Our model is 185 cm and wears', 'Vores model er 185 cm og bruger', 'Notre mannequin mesure 185 cm et porte du'],
    ['for an oversized fit, or', 'til en oversized pasform eller', 'pour un look oversize, ou du'],
    ['for a standard fit.', 'til en normal pasform.', 'pour une coupe classique.'],
    ['Want it oversized? Go one size up from your usual size.', 'Vil du have den oversized? Gå en størrelse op fra din normale størrelse.', 'Tu le veux oversize' + N + '? Prends une taille au-dessus de ta taille habituelle.'],
    ['Relaxed fit. Our model is 185 cm and wears', 'Afslappet pasform. Vores model er 185 cm og bruger', 'Coupe ample. Notre mannequin mesure 185 cm et porte du'],
    ['for a slightly oversized look.', 'til et let oversized look.', 'pour un look légèrement oversize.'],
    ['Between two sizes? Take the smaller one for a cleaner fit, the bigger one for more room over a hoodie.', 'Mellem to størrelser? Tag den mindste for en pænere pasform, den største for mere plads over en hoodie.', 'Entre deux tailles' + N + '? Prends la plus petite pour une coupe plus nette, la plus grande pour plus d’aisance par-dessus un hoodie.'],
    ['1. YOUR HEIGHT', '1. DIN HØJDE', '1. TA TAILLE (CM)'],
    ['2. FIT', '2. PASFORM', '2. COUPE'],
    ['REGULAR', 'NORMAL', 'CLASSIQUE'],
    ['OVERSIZED', 'OVERSIZED', 'OVERSIZE'],
    ['▶ WE RECOMMEND SIZE', '▶ VI ANBEFALER STØRRELSE', '▶ ON TE CONSEILLE LA TAILLE'],
    /* opgave 63: size guide when the size is sold out, and the sticky bar */
    ['▶ SIZE', '▶ STØRRELSE', '▶ LA TAILLE'],
    ['IS SOLD OUT. WE RECOMMEND', 'ER UDSOLGT. VI ANBEFALER', 'EST ÉPUISÉE. ON TE CONSEILLE LA'],
    ['IS SOLD OUT.', 'ER UDSOLGT.', 'EST ÉPUISÉE.'],
    ['CHOOSE A SIZE', 'VÆLG STØRRELSE', 'CHOISIS TA TAILLE'],
    ['MEASUREMENTS (CM)', 'MÅL (CM)', 'MESURES (CM)'],
    ['SIZE', 'STR.', 'TAILLE'],
    ['CHEST', 'BRYST', 'POITRINE'],
    ['LENGTH', 'LÆNGDE', 'LONGUEUR'],
    ['Chest is measured flat from armpit to armpit. Compare with a top you already own.', 'Brystmål er målt fladt fra ærmegab til ærmegab. Sammenlign med en trøje, du selv har.', 'La poitrine se mesure à plat, d’une aisselle à l’autre. Compare avec un haut que tu as déjà.'],
    ['NOT SURE?', 'I TVIVL?', 'UN DOUTE' + N + '?'],
    ['You have a 14-day right of withdrawal. Return it and order the right size.', 'Du har 14 dages fortrydelsesret. Send den retur og bestil den rigtige størrelse.', 'Tu disposes d’un droit de rétractation de 14 jours. Renvoie l’article et commande la bonne taille.'],

    /* notify me + weekly champion */
    ['⚠ SOLD OUT IN THIS SIZE', '⚠ UDSOLGT I DENNE STØRRELSE', '⚠ ÉPUISÉ DANS CETTE TAILLE'],
    ['Get an e-mail as soon as it is back.', 'Få en mail, så snart den er tilbage.', 'Reçois un e-mail dès son retour.'],
    ['your@email.com', 'din@mail.dk', 'ton@email.fr'],
    ['E-mail', 'E-mail', 'E-mail'],
    ['NOTIFY ME ▶', 'GIV MIG BESKED ▶', 'PRÉVIENS-MOI ▶'],
    ['We e-mail you when it is back and add you to the PAIX-V1 drop list. Unsubscribe any time.', 'Vi sender dig en mail, når den er tilbage, og tilføjer dig til PAIX-V1 drop-listen. Du kan altid afmelde dig.', 'On t’envoie un e-mail dès son retour et on t’ajoute à la liste des drops PAIX-V1. Désinscription possible à tout moment.'],
    ['✓ YOU WILL GET AN E-MAIL', '✓ DU FÅR BESKED PÅ MAIL', '✓ TU RECEVRAS UN E-MAIL'],
    ['CHECK YOUR E-MAIL ADDRESS', 'TJEK DIN E-MAILADRESSE', 'VÉRIFIE TON ADRESSE E-MAIL'],
    ['♛ WEEKLY CHAMPION! ♛', '♛ UGENS VINDER! ♛', '♛ CHAMPION DE LA SEMAINE' + N + '! ♛'],
    ['Weekly champion', 'Ugens vinder', 'Champion de la semaine'],
    ['You were #1 on the leaderboard last week. Here is your prize:', 'Du var #1 på listen sidste uge. Her er din præmie:', 'Tu étais n°1 du classement la semaine dernière. Voici ton prix' + N + ':'],
    ['20% off, one use. Tap the code to copy it.', '20% rabat, kan bruges én gang. Tryk på koden for at kopiere.', '-20' + N + '%, usage unique. Touche le code pour le copier.'],
    ['COPIED ✓', 'KOPIERET ✓', 'COPIÉ ✓'],
    ['LAST WEEK’S #1', 'SIDSTE UGES #1', 'N°1 DE LA SEMAINE DERNIÈRE'],

    /* FAQ headings + language switch */
    ['HELP SCREEN', 'HJÆLP', 'AIDE'],
    ['QUESTIONS & ANSWERS', 'SPØRGSMÅL & SVAR', 'QUESTIONS & RÉPONSES'],
    ['▸ WHO WE ARE', '▸ HVEM VI ER', '▸ QUI SOMMES-NOUS'],
    ['▸ WHAT WE OFFER', '▸ HVAD VI TILBYDER', '▸ CE QUE NOUS PROPOSONS'],
    ['Still have a question? Write to us:', 'Har du stadig et spørgsmål? Skriv til os:', 'Encore une question' + N + '? Écris-nous' + N + ':'],
    ['Q.', 'S.', 'Q.'],
    ['Language', 'Sprog', 'Langue']
  ];

  /* Text with numbers or names in it: [pattern, Danish, French]. $1 = as is, %1 = translated too. */
  var P = [
    [/^SIZE (\S+)$/, 'STR. $1', 'TAILLE $1'],
    [/^CART (\d+)$/, 'KURV $1', 'PANIER $1'],
    [/^Cart, (\d+) items$/, 'Kurv, $1 varer', 'Panier, $1 articles'],
    [/^PLAYER (\d+)$/, 'SPILLER $1', 'JOUEUR $1'],
    [/^(.+) \(YOU\)$/, '%1 (DIG)', '%1 (TOI)'],
    [/^(.+) \(YOU!\)$/, '%1 (DIG!)', '%1 (TOI' + N + '!)'],
    [/^LVL (.+)$/, 'NIV. $1', 'NIV. $1'],
    [/^LEVEL (\d+)$/, 'NIVEAU $1', 'NIVEAU $1'],
    [/^REACHED LEVEL (\d+)$/, 'NÅEDE NIVEAU $1', 'NIVEAU $1 ATTEINT'],
    [/^STAGE: (.+)$/, 'BANE: %1', 'ZONE' + N + ': %1'],
    [/^BOSS: (.+)$/, 'BOSS: %1', 'BOSS' + N + ': %1'],
    [/^NEW: (.+)$/, 'NYE: %1', 'NOUVEAU' + N + ': %1'],
    [/^SHIP UPGRADES: (\d+)$/, 'SKIBSOPGRADERINGER: $1', 'AMÉLIORATIONS' + N + ': $1'],
    [/^(RESPECT|LOYALTY|FREEDOM|CULTURE|PEACE) (\d+)$/, '%1 $2', '%1 $2'],
    [/^([A-Z0-9 \-]+) \/ ([A-Z0-9 \-]+)$/, '%1 / %2', '%1 / %2'],
    [/^([A-Z0-9 \-]+) \+ ([A-Z0-9 \-]+)$/, '%1 + %2', '%1 + %2'],
    [/^\+(\d+) POINTS \((\d+)\/(\d+) TODAY\)$/, '+$1 POINT ($2/$3 I DAG)', '+$1 POINTS ($2/$3 AUJOURD’HUI)'],
    [/^VALID UNTIL (.+)$/, 'GYLDIG TIL $1', 'VALABLE JUSQU’AU $1'],
    [/^Progress to (.+)$/, 'Fremskridt mod $1', 'Progression vers $1'],
    [/^(\S+) POINTS TO (.+)$/, '$1 POINT TIL $2', 'ENCORE $1 POINTS AVANT $2'],
    [/^MINIMUM ORDER: (.+)$/, 'MINDSTEKØB: $1', 'COMMANDE MINIMUM' + N + ': $1'],
    [/^NEED (\S+) MORE$/, 'MANGLER $1', 'IL TE MANQUE $1'],
    [/^NEED (\S+)$/, 'MANGLER $1', 'IL TE MANQUE $1'],
    [/^CONFIRM -(\S+) PTS\?$/, 'BEKRÆFT -$1 PTS?', 'CONFIRMER -$1 PTS' + N + '?'],
    [/^CONFIRM -(\S+)\?$/, 'BEKRÆFT -$1?', 'CONFIRMER -$1' + N + '?'],
    [/^REWARD UNLOCKED: (.+)$/, 'BELØNNING LÅST OP: $1', 'RÉCOMPENSE DÉBLOQUÉE' + N + ': $1'],
    [/^EARN (\S+) PTS PER 1 (\w+) SPENT$/, 'FÅ $1 POINT PR. 1 $2, DU HANDLER FOR', 'GAGNE $1 PTS PAR 1 $2 DÉPENSÉ'],
    [/^EARN (\S+) PTS PER 1 (\w+) SPENT · UP TO (\S+) PTS\/DAY FROM THE ARCADE \((\S+) TODAY\)$/, 'FÅ $1 POINT PR. 1 $2, DU HANDLER FOR · OP TIL $3 POINT/DAG FRA ARKADEN ($4 I DAG)', 'GAGNE $1 PTS PAR 1 $2 DÉPENSÉ · JUSQU’À $3 PTS/JOUR À L’ARCADE ($4 AUJOURD’HUI)'],
    [/^(\S+) · EXPIRED$/, '$1 · UDLØBET', '$1 · EXPIRÉ'],
    [/^OPENS (.+)$/, 'ÅBNER $1', 'OUVRE LE $1'],
    [/^(ROOKIE|STREET|ELITE) ONLY$/, 'KUN %1', 'NIVEAU %1 REQUIS'],
    [/^(\d+)% OFF$/, '$1% RABAT', '-$1' + N + '%'],
    [/^YOUR RANK: #(\d+) - BEST (.+)$/, 'DIN PLACERING: #$1  -  BEDSTE $2', 'TON RANG' + N + ': #$1  -  RECORD $2'],
    [/^SAVED! YOU ARE NOW (.+)\.$/, 'GEMT! DU HEDDER NU $1.', 'ENREGISTRÉ' + N + '! TU T’APPELLES MAINTENANT $1.'],
    [/^(\d+D )?(\d+)H (\d\d)M$/, null, function (m) { return (m[1] ? m[1].replace('D', 'J') : '') + m[2] + 'H ' + m[3] + 'M'; }],
    [/^NEXT DROP: (.+)$/, 'NÆSTE DROP: $1', 'PROCHAIN DROP' + N + ': $1'],
    [/^Next drop: (.+)$/, 'Næste drop: $1', 'Prochain drop' + N + ': $1'],
    [/^HITS (\d)\/3$/, 'TRÆF $1/3', 'TOUCHÉ $1/3'],
    [/^\+(\S+) PTS AFTER CHECKOUT$/, null, '+$1 PTS APRÈS LA COMMANDE'],
    [/^LOG IN TO EARN (\S+) PTS$/, null, 'CONNECTE-TOI POUR GAGNER $1 PTS'],
    [/^\+(\S+) PTS WELCOME BONUS$/, '+$1 PTS VELKOMSTBONUS', '+$1 PTS BONUS DE BIENVENUE'],
    [/^ORDER COMPLETE · \+(\S+) PTS$/, 'ORDRE GENNEMFØRT · +$1 PTS', 'COMMANDE VALIDÉE · +$1 PTS'],
    [/^(\S+) PTS · LVL (.*)$/, '$1 PTS · NIV. $2', '$1 PTS · NIV. $2'],
    [/^(.+) READY$/, '$1 ER KLAR', '$1 PRÊT'],
    [/^& EARN (\S+) PTS$/, '& FÅ $1 POINT', '& GAGNE $1 PTS'],
    [/^▶ \+(\S+) PTS WITH THIS ORDER$/, null, '▶ +$1 PTS AVEC CETTE COMMANDE'],
    [/^€(\d+)[.,](\d\d)$/, null, '$1,$2' + N + '€'],
    [/^([A-Z]{3}) (\d+)\.(\d\d)$/, null, '$2,$3' + N + '$1'],
    [/^Answer$/, 'Svar', 'Réponse']
  ];

  var IDX = L === 'da' ? 1 : L === 'fr' ? 2 : 0;
  function norm(s) { return String(s).replace(/[\s  ]+/g, ' ').trim(); }
  var MAP = {};
  W.forEach(function (w) { MAP[norm(w[0])] = w; });

  /* 1,234 -> 1.234 (Danish) / 1 234 (French) */
  function nums(s) {
    if (!IDX) return s;
    return s.replace(/\b\d{1,3}(?:,\d{3})+\b/g, function (n) { return n.replace(/,/g, IDX === 1 ? '.' : ' '); });
  }
  /* SPEED: remember every lookup (also misses), so each text only runs through the patterns once */
  var MEMO = Object.create(null), MEMO_N = 0;
  function tr(s) {
    if (!IDX || s == null) return s;
    s = String(s);
    var k = norm(s);
    if (!k || k.length > 400) return s;
    var out = MEMO[k];
    if (out === undefined) {
      out = look(k);
      if (MEMO_N++ < 5000) MEMO[k] = out;
    }
    if (out == null) return s;
    var lead = s.match(/^[\s ]*/)[0], tail = s.match(/[\s ]*$/)[0];
    return lead + out + tail;
  }
  function look(k) {
    var out = null;
    var hit = MAP[k];
    if (hit) out = hit[IDX];
    else {
      for (var i = 0; i < P.length; i++) {
        var m = k.match(P[i][0]);
        if (!m) continue;
        var t = P[i][IDX];
        if (t == null) break;
        out = typeof t === 'function' ? t(m) : t.replace(/([$%])(\d)/g, function (_, how, n) { var g = m[+n] || ''; return how === '%' ? norm(tr(g)) : g; });
        break;
      }
    }
    return out;
  }
  window.PXT = tr;
  window.PXLANG = L;

  /* ---------- 3. Translate the page as it is built ---------- */
  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, CODE: 1, PRE: 1, TEMPLATE: 1 };
  var PX_SCOPE = '[class*="px"],[data-px-player],[data-pxl],[data-px-arcade],#pxd';
  /* SPEED (opgave 37): checks one element only (the contenteditable attribute instead of isContentEditable, which made the
     browser recalculate styles). walk() uses it to leave out whole branches; skipEl() still checks all parents for single nodes. */
  function skipSelf(e) {
    if (SKIP[e.nodeName]) return true;
    var c = e.classList;
    if (c && (c.contains('rte') || c.contains('pxlang'))) return true;
    if (!e.getAttribute) return false;
    if (e.hasAttribute('data-pxt-skip')) return true;
    var ce = e.getAttribute('contenteditable');
    return ce !== null && ce !== 'false';
  }
  function skipEl(el) {
    for (var e = el; e && e.nodeType === 1; e = e.parentNode) if (skipSelf(e)) return true;
    return false;
  }
  function doText(n, checked) {
    var p = n.parentNode;
    if (!p || (!checked && skipEl(p))) return;
    var v = n.nodeValue;
    if (!v || !/[A-Za-z€\d]/.test(v)) return;
    var out = tr(v);
    if (p.closest && p.closest(PX_SCOPE)) out = nums(out);
    if (out !== v) n.nodeValue = out;
  }
  var ATTRS = ['aria-label', 'placeholder', 'title'];
  function doAttrs(el, checked) {
    if (!checked && skipEl(el)) return;
    for (var i = 0; i < ATTRS.length; i++) {
      var v = el.getAttribute(ATTRS[i]);
      if (v) { var out = tr(v); if (out !== v) el.setAttribute(ATTRS[i], out); }
    }
    if (el.nodeName === 'A') fixLink(el);
  }
  /* Links inside the arcade parts point at the English pages; send them to the same language */
  function fixLink(a) {
    var h = a.getAttribute('href');
    if (!h || h.charAt(0) !== '/' || h.charAt(1) === '/') return;
    /* SHOP = clothes only; the gift card has its own menu item */
    if (/^(\/(da|fr))?\/collections\/all(?=[\/?#]|$)/.test(h)) { h = h.replace('/collections/all', '/collections/shop'); a.setAttribute('href', h); }
    /* The gift card is in Danish kroner and can only be bought in Denmark: hide it for visitors from other countries */
    if (LOC.c && LOC.c !== 'DK' && /\/products\/(gift-card|gavekort|carte-cadeau)(?=[\/?#]|$)/.test(h)) { var li = a.closest('li') || a; li.hidden = true; li.style.display = 'none'; return; }
    if (L === 'en') return;
    if (PRE.test(h) || /^\/(apps|cdn|services|tools|checkout|checkouts|wpm|\.well-known)(\/|$)/.test(h)) return;
    if (a.closest('.pxlang')) return;
    a.setAttribute('href', '/' + L + (h === '/' ? '' : h.charAt(1) === '#' || h.charAt(1) === '?' ? h.slice(1) : h));
  }
  function walk(root) {
    if (root.nodeType === 3) { doText(root); return; }
    if (root.nodeType !== 1 && root.nodeType !== 9 && root.nodeType !== 11) return;
    if (root.nodeType === 1) { if (skipEl(root)) return; doAttrs(root, true); }
    /* SPEED (opgave 37): a skipped element is left out with all its children, so every node is checked only once */
    var tw = document.createTreeWalker(root, 5, { acceptNode: function (x) { return x.nodeType === 1 && skipSelf(x) ? 2 : 1; } }), n;
    while ((n = tw.nextNode())) { if (n.nodeType === 3) doText(n, true); else doAttrs(n, true); }
  }
  function addSwitch() {
    var spots = document.querySelectorAll('.px-arcade__menu, .pxhud');
    spots.forEach(function (spot) {
      var next = spot.nextElementSibling;
      /* Omar 16/10: on the homepage EN · DA · FR shares a line with the country selector, inside .px-arcade__locale */
      var nav = spot.querySelector('.pxlang') || (next && next.classList.contains('pxlang') ? next : null) || (next && next.classList.contains('px-arcade__locale') ? next.querySelector('.pxlang') : null);
      if (nav && !nav.hasAttribute('data-pxlang-ssr')) return;
      var fresh = !nav;
      if (fresh) {
        nav = document.createElement('nav');
        nav.className = 'pxlang';
        nav.setAttribute('aria-label', ['Language', 'Sprog', 'Langue'][IDX]);
      } else {
        /* SPEED (opgave 37): the homepage draws EN · DA · FR on the server. Rebuild its links here with the rule below. */
        nav.removeAttribute('data-pxlang-ssr');
        nav.textContent = '';
      }
      /* Arbejdskø 36 (Omars endelige regel): EN · DA · FR change ONLY the language. The currency follows the country
         (IP via paix-geo, or the visitor's own pick in the country selector). Shopify keeps the country per language
         path (/, /da, /fr), so every link passes the current country on, and the currency stays the same after the click.
         paix-geo removes ?country from the address bar after the page has loaded, so the country selector still works. */
      /* The target country from paix-geo (px_cc: IP country or the visitor's own pick), else the country of this page */
      var cc = (document.cookie.match(/(?:^|; )px_cc=([A-Z]{2})(?:;|$)/) || [])[1];
      var here = cc || String(LOC.c || '').toUpperCase();
      LANGS.forEach(function (x, i) {
        if (i) { var dot = document.createElement('span'); dot.setAttribute('aria-hidden', 'true'); dot.textContent = '·'; nav.appendChild(dot); }
        var q = new URLSearchParams(location.search);
        var country = here;
        if (country) q.set('country', country); else q.delete('country');
        var a = document.createElement('a');
        a.href = urlFor(x) + (q.toString() ? '?' + q.toString() : '') + location.hash;
        a.hreflang = x; a.lang = x; a.title = { en: 'English', da: 'Dansk', fr: 'Français' }[x] || x;
        if (x === L) a.setAttribute('aria-current', 'true');
        a.textContent = x.toUpperCase();
        nav.appendChild(a);
      });
      nav.addEventListener('click', function () { save('pxLangAuto', '1'); });
      if (!fresh) return;
      if (spot.classList.contains('pxhud')) spot.appendChild(nav); else spot.insertAdjacentElement('afterend', nav);
    });
  }
  var css = document.createElement('style');
  css.textContent =
    '.pxlang{display:flex;justify-content:center;align-items:center;gap:6px;margin:10px 0 0;font:9px/1 "Press Start 2P",monospace;letter-spacing:.1em;color:rgb(140 200 255/.6)}' +
    '.pxlang a{display:inline-block;padding:7px 6px;color:#8cc8ff;text-decoration:none;border:1px solid transparent}' +
    '.pxlang a:hover,.pxlang a:focus-visible{color:#e2f0ff;border-color:rgb(47 139 255/.6);outline:none}' +
    '.pxlang a[aria-current]{color:#02040a;background:#8cc8ff}' +
    '.pxhud .pxlang{margin:0;font-size:8px}.pxhud .pxlang a{padding:2px 4px}' +
    /* Easy to use: big enough to tap on a phone, and a clear outline when using the keyboard */
    '.pxlang a{min-width:44px;min-height:44px;display:inline-flex;align-items:center;justify-content:center}.pxhud .pxlang a{min-height:32px;min-width:36px}' +
    'a:focus-visible,button:focus-visible,summary:focus-visible,[role=button]:focus-visible{outline:3px solid #8cc8ff!important;outline-offset:2px}';
  (document.head || html).appendChild(css);

  /* Canvas text in the game */
  if (IDX && window.CanvasRenderingContext2D) {
    var C2 = CanvasRenderingContext2D.prototype;
    ['fillText', 'strokeText'].forEach(function (fn) {
      var orig = C2[fn];
      C2[fn] = function (t) { var a = Array.prototype.slice.call(arguments); a[0] = tr(t); return orig.apply(this, a); };
    });
  }

  var queued = [];
  function flush() {
    var list = queued; queued = [];
    for (var i = 0; i < list.length; i++) {
      var r = list[i];
      if (r.type === 'characterData') doText(r.target);
      else if (r.type === 'attributes') doAttrs(r.target);
      else for (var j = 0; j < r.addedNodes.length; j++) walk(r.addedNodes[j]);
    }
    addSwitch();
  }
  var mo = new MutationObserver(function (recs) {
    if (IDX) { for (var i = 0; i < recs.length; i++) queued.push(recs[i]); flush(); }
    else {
      for (var k = 0; k < recs.length; k++) for (var j = 0; j < recs[k].addedNodes.length; j++) fixAll(recs[k].addedNodes[j]);
      addSwitch();
    }
  });
  function fixAll(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.nodeName === 'A') fixLink(root);
    root.querySelectorAll('a[href^="/"]').forEach(fixLink);
  }
  mo.observe(html, IDX ? { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-label', 'placeholder', 'title', 'href'] } : { childList: true, subtree: true });
  function ready() { if (IDX && document.body) walk(document.body); else fixAll(document.body); addSwitch(); html.classList.add('pxt-ready'); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
})();